import aspectRatio from "@tailwindcss/aspect-ratio";
import { Config } from "tailwindcss";
import tailwindColors from "tailwindcss/colors";
import defaultTheme from "tailwindcss/defaultTheme";

import { colors } from "./frontend/tailwindV1Colors";

// const { colors } = require("./frontend/tailwindV1Colors");
// const tailwindColors = require("tailwindcss/colors");

/* This is less than ideal
 But onsite use the default tailwind fontsizes and the management site does not.
 in order to get the correct font sizes in the mobile menu preview we need to manually import them
 if we ever fix the management site typography we can remove this
 The these fonts are being used in the menus.css to overide the text-* classes in #MobileMenuPreview
 */

const veneuePreviewFontSizes = Object.entries(defaultTheme.fontSize).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [`venue-preview-${key}`]: value,
  }),
  {}
);
export default {
  content: [
    "./frontend/app/**/*.{js,ts,tsx,jsx}",
    "./frontend/onsite_app/*.{js,ts,tsx,jsx}",
    "./frontend/onsite_app/**/*.{js,ts,tsx,jsx}",

    "./frontend/welcome/*.{js,ts,tsx,jsx}",
    "./frontend/welcome/**/*.{js,ts,tsx,jsx}",
    "./app/views/**/*.html.erb",
  ],
  theme: {
    screens: {
      // Less than this equates to phones
      sm: "640px",
      // => @media (min-width: 640px) { ... }

      // Between these two value is generally an iPad in portrait mode
      // This is also 124px bigger than Tailwinds so that the side bar
      // doesn't show on the portrait ipad
      md: "896px",
      // => @media (min-width: 896px) { ... }

      // Anything bigger than this is a desktop
      lg: "1024px",
      // => @media (min-width: 1024px) { ... }

      xl: "1280px",
      // => @media (min-width: 1280px) { ... }

      "2xl": "1536px",

      print: { raw: "print" },
    },
    spacing: {
      "-24": "-24px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px",
      12: "12px",
      16: "16px",
      24: "24px",
      32: "32px",
      48: "48px",
      64: "64px",
      96: "96px",
      128: "128px",
      192: "192px",
      256: "256px",
      384: "384px",
      512: "512px",
      640: "640px",
    },
    fontSize: {
      xs: "12px",
      base: "14px",
      lg: "16px",
      xl: "20px",
      "2xl": "24px",
      "3xl": "30px",
      "4xl": "36px",
      "5xl": "48px",
      "6xl": "64px",
      ...veneuePreviewFontSizes,
    },
    colors: {
      venue: {
        primary: "var(--venue-primary)",
        secondary: "var(--venue-secondary)",
        tertiary: "var(--venue-tertiary)",
        highlight: "var(--venue-highlight)",
      },
      primary: {
        100: "#E0E6EB",
        200: "#D3E5FD",
        300: "#82A3BF",
        400: "#4A7191",
        500: "#2F4860",
        1000: "#1C2C3A",
      },
      accent: {
        100: "#F0F6FF",
        200: "#D9E9FC",
        300: "#C4DDFD",
        400: "#A3CCFF",
        500: "#8BBFFF",
        600: "#6DA1DF",
        700: "#387BCC",
        800: "#2156AB",
        900: "#1B478D",
        1000: "#0C2D55",
      },
      neutral: tailwindColors.gray, // was coolGray  in tailwind V2
      background: tailwindColors.slate[50], // Was blueGray in TailwindV2
      "posboss-blue": "#389ABB",
      "regulr-red": "#FF3438",
      "paperless-green": "#57CAA9",
      "sogui-yellow": "#FFAE14",

      "sogui-brand": {
        100: "#FFEDC9",
        200: "#FFE8ED",
        500: "#F4406B",
        green: "#66F343",
      },
      "bustle-pink": "#F8E7E3",
      bustle: {
        "pink-icing": "#FBE7E2",
        chalkboard: "#2A2A2E",
      },
      black: colors.black,
      white: colors.white,
      "posboss-brand-gradient-blue": "#ABDAFC",
      "paperless-brand-gradient-green": "#B1EDD1",
      "posboss-red": "#F9423A",
      "posboss-pink": "#ee2f6b",
      "regulr-pink": "#f1655f",
      "regulr-brand": "#F44336",
      "posboss-gradient-primary": "#AFD6E3",
      "posboss-gradient-secondary": "#BCE9DB",
      red: colors.red,
      yellow: colors.yellow,
      green: colors.green,
      blue: colors.blue,
      indigo: colors.indigo,
      purple: colors.purple,
      teal: colors.teal,
      pink: colors.pink,
      orange: colors.orange,
      transparent: "transparent",
    },
    extend: {
      maxWidth: {
        "5/6": "calc(100%/6 * 5)",
        256: "256px",
      },
      maxHeight: {
        0: "0px",
        "4/5": "80%",
        192: "192px",
      },
      minHeight: {
        "4/5": "80%",
        256: "256px",
      },
      minWidth: {
        0: "0",
        48: "48px",
        "1/10": "10%",
      },
      boxShadow: {
        outline: "0 0 0 2px rgba(139, 191, 255,0.5)",
        "venue-brand-style": "var(--venue-box-shadow)",
      },
      cursor: {
        grab: "grab",
      },
      borderRadius: {
        phone: "28px",
        "venue-brand": "var(--venue-border-radius)",
      },
      aspectRatio: {
        ipad: "4/3",
      },
    },
    transitionProperty: {
      "margin-left": "margin-left",
      "margin-bottom": "margin-bottom",
      height: "height",
    },
  },
  plugins: [aspectRatio],
} satisfies Config;
